{
  "clear": "清除",
  "invalid": "(無效)",
  "loading": "正在載入...",
  "noResults": "無任何結果",
  "valid": "(有效)"
}
